import React from 'react';
import styled from 'styled-components';
import { Form, Button } from 'react-bootstrap';
import Email from '../Email';
import Password from '../Password';
import ConfirmPassword from '../ConfirmPassword';
import { AlertMessage2 } from '../../../components';
import { withLoading, withAlert, withForm } from '../../../hoc';
import { passwordLength } from '../../../config/ProjectConfig';
import config from '../../../config/config';

const PasswordContent = styled.div`
    margin-bottom: 100px;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 100px;
    & form {
        background-color: #fff;
        padding: 20px;
        margin-top: 15px;
        box-shadow: 0 0.4rem 0.8rem -0.1rem rgba(0, 32, 128, 0.1),
            0 0 0 1px #f0f2f7;
    }
`;
const H1 = styled.h1`
    font-size: 28px;
    color: #333;
    text-align: center;
`;
const RowWrapper = styled.div`
    margin: 15px 0;

    & .form-label {
        margin-bottom: 5px;
    }
`;
const RowWrapperButton = styled.div`
    margin: 25px 0 10px 0;

    & button {
        margin: 0px !important;
    }
`;
const CenterDiv = styled.div`
    text-align: center;
    margin: 25px 0;

    & a {
        font-size: 16px;
        color: #000;
        display: block;

        &:hover {
            text-decoration: underline !important;
        }
    }
` 
const ResetPasswordForm = ({
    responseData = {},
    formState,
    messageState = {}, 
    onSubmit,
    onChange,
    actions = {},
}) => {
    const { routes } = config;

    const onConfirmPassword = (e) => {
        let isPasswordCorrect = !!(
            e.target.checkValidity() &&
            e.target.value.length >= passwordLength &&
            e.target.value === formState.password.value
        );
        onChange(e, isPasswordCorrect);
    };
    const onSubmitForm = (e) => {
        e.preventDefault();

        onSubmit(
            (formData) => {
                actions.saveNewPassword({
                    body: formData,
                });
            },
            {
                confirmPassword: {
                    ...formState['confirmPassword'],
                    isValid:
                        formState.confirmPassword.value.length > 0 &&
                        formState.password.value ===
                            formState.confirmPassword.value,
                },
            },
        );
    };

    return (
        <PasswordContent>
            <H1>Zmień aktualne hasło</H1>
            <Form onSubmit={onSubmitForm} noValidate>
                <RowWrapper>
                    <Email userEmail={responseData.email} />
                </RowWrapper>
                <RowWrapper>
                    <Password password={formState.password} onChange={onChange} />
                </RowWrapper>
                
                <ConfirmPassword
                    confirmPassword={formState.confirmPassword}
                    onChange={onConfirmPassword}
                />
                <RowWrapperButton>
                    <Button variant="danger" type="submit">
                        Zmień hasło
                    </Button>
                </RowWrapperButton>

                <AlertMessage2
                    {...messageState.saveNewPassword} 
                    isLoaded={formState.isLoaded}
                    loadingName={formState.loadingName}
                />
            </Form>
            <CenterDiv>
                <a href={routes.dashboard.logIn}>Powrót do logowania</a>
            </CenterDiv>
        </PasswordContent>
    );
};

export default withForm({
    component: withLoading(withAlert(ResetPasswordForm)),
    clearFormToDefaultState: true,
    actions: [
        {
            name: 'saveNewPassword',
            url: '/api/auth/reset-password/:id',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            method: 'POST',
            successMessage: 'Hasło zostało zmienione',
            errorMessage: 'Zmiana hasła się nie powiodła',
            showErrorMessage: true,
            showSuccessMessage: true,
        },
    ],
    localState: {
        loadingName: '',
        password: {
            value: '',
            isValid: null,
        },
        confirmPassword: {
            value: '',
            isValid: null,
        },
    },
});
